const QatarSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112191)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9996 20C39.9996 8.95437 31.0452 0 19.9996 0C16.0871 0 12.4376 1.12461 9.3549 3.06648L13.7387 4.92906L7.82568 7.44141L13.7387 9.95367L7.82568 12.4659L13.7387 14.978L7.82568 17.4898L13.7387 20.0014L7.82568 22.5136L13.7387 25.0256L7.82568 27.5374L13.7387 30.0495L7.82568 32.5616L13.7387 35.0734L9.35686 36.935C12.4391 38.8759 16.0879 40 19.9996 40C31.0452 40 39.9996 31.0456 39.9996 20Z"
        fill="#751A46"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112191">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default QatarSvg;
